import meat_dots from './resources/meat-dots.svg'

const HamburgerMenu = () => {
    return(
        <div>
            <img src={meat_dots} alt='ham' className='mr-4'></img>
        </div>
    )
}

export default HamburgerMenu